export const percentToFraction = (value: number) => {
  return value / 100
}
